<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:39:11+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Slides with the Commercial Services of Lorinthe
@Last modified by:   tom
@Last modified time: 2019-06-12T17:25:32+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">

  <!-- class="bg-primary" -->
  <section id="puckslides" class="pt-2 pb-4">
    <!-- <h1 class="text-secondary" v-html="$t('puck.slides.title')" /> -->
    <!-- <br> -->
    <slideshow
      :slides="[
        assetUrl('img/carousel/seniors-alone.jpg'),
        assetUrl('img/carousel/unexpected-moments.jpg'),
        assetUrl('img/carousel/safe-connected.jpg'),
        assetUrl('img/carousel/mutual-care.jpg')
      ]"
      folder=""
      width="1200"
      height="600"
      label-pre-fix="puck.slides"
    />

  </section>

</template>

<script>
export default {
}

</script>

<style lang="scss" scoped>

  #puckslides {
    padding-bottom: 0;
    .carousel {
      border: 1px solid $secondary;
    }
  }
</style>
